<template>
  <el-dialog class="editor-dialog" :visible.sync="visible" :show-close="false" width="85%" top="5vh">
    <div class="my-header">
      <span>{{ '采购单#'+sn+'_'+suppliername+'_采购明细' }}</span>
      <el-button class="button" type="primary" size="mini" @click="exportContract(row)">合同模板</el-button>
    </div>
    <el-row>
    <el-col :span="24">
    <el-card shadow="always" body-style="text-align:center;padding:0px;" id='tableCard'>
      <el-table :data="row.items" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" height='600px' border stripe :header-cell-style="headerStyle" :row-style="{height:'45px'}" show-summary :summary-method="getSummaries">
        <el-table-column prop="SN" label="物料号" align="center" width="70"></el-table-column>
        <el-table-column prop="Name" label="物料名称" align="center" min-width="90"></el-table-column>
        <el-table-column prop="Description" label="物料描述" align="center" min-width="200"></el-table-column>
        <el-table-column prop="Brand" label="品牌" align="center" min-width="100"></el-table-column>
        <el-table-column prop="Unit" label="单位" align="center" min-width="80"></el-table-column>
        <el-table-column prop="Quantity" label="数量" align="center" min-width="80"></el-table-column>
        <el-table-column label="单价" min-width="100" align="center" :formatter="calcUnitPrice"></el-table-column>
        <el-table-column label="合价" min-width="100" align="center" :formatter="calcSubtotalPrice"></el-table-column>
        <el-table-column  label="已入库数量" min-width="100" align="center" :formatter="calcCheckIn"></el-table-column>
        <el-table-column label="订单附件" align="center" min-width="100">
          <template slot-scope="scope">
            <div style="display:flex;flex-flow:row wrap;justify-content:center;">
              <div v-for="(file,index) in scope.row.Attachments" :key="index" style="position: relative;">
                <el-tooltip class="item" effect="dark" :disabled="scope.row.isEdit" :content="file.filename" placement="top">
                  <el-image class="image" v-if="['.pdf','.PDF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(file.path)"></el-image>
                  <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="入库附件" align="center" min-width="100">
          <template slot-scope="scope">
            <div style="display:flex;flex-flow:row wrap;justify-content:center;">
              <div v-for="(file,index) in scope.row.Attachment_Checkins" :key="index" style="position: relative;">
                <el-tooltip class="item" effect="dark" :disabled="scope.row.isEdit" :content="file.filename" placement="top">
                  <el-image class="image" v-if="['.pdf','.PDF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                  <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(file.path)"></el-image>
                  <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Inquiry.Remark" label="备注" min-width="90" align="center"></el-table-column>
      </el-table>
    </el-card>
    </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import http from '@/http'
import {ContractTemp_1} from './ContractTemp_1/index'
import {ContractTemp_2} from './ContractTemp_2/index'
export default {
  data() {
    return {
      row:{},
      sn:'',
      suppliername:'',
      visible:false
    }
  },
  methods:{
    calcUnitPrice(row, column, cellValue, index){
      if(row.Inquiry.Currency=='USD'){
        return row.Inquiry.UnitPrice.toLocaleString('en-US', { style: 'currency', currency:'USD' })
      }else{
        return row.Inquiry.UnitPrice.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
      }
    },
    calcSubtotalPrice(row, column, cellValue, index){
      if(row.Inquiry.Currency=='USD'){
        return (row.Inquiry.UnitPrice*row.Quantity).toLocaleString('en-US', { style: 'currency', currency:'USD' })
      }else{
        return (row.Inquiry.UnitPrice*row.Quantity).toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
      }
    },
    calcCheckIn(row, column, cellValue, index){
      return row.Checkins.length>0?row.Checkins[0].totalAmount:0
    },
    async exportContract(row){
      let BuyerInfo={}
      let ContractTerm=[]
      const buyerInfo=await http.get('/setting/basicInfo')
      const supplier=await http.get(`/srm/supplier/id/${row.supplier}`);
      if(buyerInfo.data&&buyerInfo.data.length){
        BuyerInfo=buyerInfo.data[0].Company
        ContractTerm=buyerInfo.data[0].ContractTerm.map((i,index)=>{
          return `${this.convertToChinaNum(index+2)}、${i}`
        })
      }     
      const title=`#${sn}_${supplier.data.name}_采购合同.xlsx`
      if(row.items.length<6){
        ContractTemp_1(title,row.items,BuyerInfo,supplier.data.basicInfo||{},ContractTerm)
      }else{
        ContractTemp_2(title,row.items,BuyerInfo,supplier.data.basicInfo||{},ContractTerm)
      }
    },
    convertToChinaNum(num) {
      let arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      let arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿'];//可继续追加更高位转换值
      if(!num || isNaN(num)){
          return "零";
      }
      let english = num.toString().split("")
      let result = "";
      for (let i = 0; i < english.length; i++) {
          let des_i = english.length - 1 - i;//倒序排列设值
          result = arr2[i] + result;
          let arr1_index = english[des_i];
          result = arr1[arr1_index] + result;
      }
      //将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
      //合并中间多个零为一个零
      result = result.replace(/零+/g, '零');
      //将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
      //将【亿万】换成【亿】
      result = result.replace(/亿万/g, '亿');
      //移除末尾的零
      result = result.replace(/零+$/, '')
      //将【零一十】换成【零十】
      //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
      //将【一十】换成【十】
      result = result.replace(/^一十/g, '十');
      return result;
    },
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '总计';
          }else if(index ===5){
            sums[index]=data.reduce((pre,cur)=>{
              return pre+cur.Quantity
            },0)
          }else if(index === 7){
            let currency
            const amount=data.reduce((pre,cur)=>{
              currency=cur.Inquiry.Currency
              return pre+cur.Inquiry.UnitPrice*cur.Quantity
            },0)
            if(currency=='USD'){
              sums[index]= amount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
            }else{
              sums[index]= amount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
            }
          }else if(index === 8){
            sums[index]=data.reduce((pre,cur)=>{
              const QTY_Checkins=cur.Checkins.length>0?cur.Checkins[0].totalAmount:0
              return pre+QTY_Checkins
            },0)
          }
          else {
            sums[index] = '';
          }
        });
        return sums;
    },
    async previewAttachment(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      window.open(res.data)
    },
    async previewImage(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      this.$hevueImgPreview({url:res.data})
    },
  }
};
</script>
<style scoped>
#tableCard >>>.el-table .cell{
  line-height: 1.3!important;
  padding: 0;
}
.editor-dialog>>>.el-upload{
  display:contents;
}
.el-table .cell p{
  margin: 0!important;
}
/*鼠标移入某行时的背景色*/
#tableCard >>>.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fad8bca4!important;
}
#tableCard >>>.el-table__body tr.current-row > td {
  background-color: #c6e4f8b4 !important;
}
.editor-dialog>>>.el-dialog__body {
  padding: 0;
}
.editor-dialog>>>.el-dialog__header {
  padding: 0;
}
.image{
  height: 40px;
  width:40px;
  cursor: pointer;
  margin: 0 5px;
}
.my-header{
  height: 35px;
  line-height: 35px;
  position: relative;
  padding: 0;
  text-align: center;
}
.my-header span{
  font-weight: 700;
  font-size: 16px;
}
.my-header .button{
  position:absolute;
  right:5px;
  top:5px;
}
</style>
